import React from 'react';
import { EnvironmentCheckItemToRender } from '../CheckResults';
import { Icon } from '@fluentui/react';
import translationsProvider from 'translations/translationsProvider';
import translationKeys from 'translationKeys';

enum EnvironmentCheckStatus {
	Success = 'Success',
	Completed = 'Completed',
	Matching = 'Matching',
	Saved = 'Saved',
	Configured = 'Configured',
	Executed = 'Executed',
	Failed = 'Failed',
	Error = 'Error',
	Issue = 'Issue',
	NotRun = 'NotRun',
}

interface IThumbnailColumnProps {
	item: EnvironmentCheckItemToRender;
}

const ThumbnailColumn = ({ item }: IThumbnailColumnProps) => {
	if (item.children) return <Cube isSuccess={item.status === EnvironmentCheckStatus.Completed} />;

	switch (item.status) {
	case EnvironmentCheckStatus.Success:
	case EnvironmentCheckStatus.Completed:
	case EnvironmentCheckStatus.Matching:
	case EnvironmentCheckStatus.Saved:
	case EnvironmentCheckStatus.Configured:
	case EnvironmentCheckStatus.Executed:
		return <Success />;
	case EnvironmentCheckStatus.Failed:
	case EnvironmentCheckStatus.Error:
	case EnvironmentCheckStatus.NotRun:
		return <Error />;
	case EnvironmentCheckStatus.Issue:
		return <Warning />;
	default:
		return <span title={item.status}>{item.status}</span>;
	}
};

enum StatusColor {
	Success = '#107C10',
	Warning = '#F7630C',
	Error = '#E0181A',
	Info = '#4A87B5'
}

const Success = () => <Icon iconName="SkypeCircleCheck" role="img" aria-label={translationsProvider.staticTranslate(translationKeys.CheckResult.Icons.Success.AriaLabel)} styles={{ root: { color: StatusColor.Success } }} />;
const Error = () => <Icon iconName="StatusErrorFull" role="img" aria-label={translationsProvider.staticTranslate(translationKeys.CheckResult.Icons.Error.AriaLabel)} styles={{ root: { color: StatusColor.Error } }} />;
const Warning = () => <Icon iconName="InfoSolid" role="img" aria-label={translationsProvider.staticTranslate(translationKeys.CheckResult.Icons.Warning.AriaLabel)} styles={{ root: { color: StatusColor.Warning } }} />;
const Cube = ({ isSuccess }) => <Icon iconName="CubeShape" role="img" aria-label={translationsProvider.staticTranslate(translationKeys.CheckResult.Icons.Cube.AriaLabel)} styles={{ root: { color: isSuccess ? StatusColor.Info : StatusColor.Warning, fontSize: '20px', marginLeft: '-4px' } }} />;


export default ThumbnailColumn;
